module.exports = __webpack_public_path__ + "img/features04-06.03d8a15.png";